module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/34-e725e5cf7409429b790c5441e7c5cfc9.jpg";